'use strict';

const prefix = 'vue_' // avoid same localstorage names like in previous versions
export const bagsize = prefix + 'sizeId'
export const body = prefix + 'bodyId'
export const edge = prefix + 'edgeId'
export const thread = prefix + 'threadId'
export const inside = prefix + 'insideId'
export const pocket = prefix + 'pocketId'
export const side = prefix + 'sideId'
export const front = prefix + 'frontId'
export const tack = prefix + 'tackId'
export const back = prefix + 'backId'
export const namechar = prefix + 'namechar'
export const namethread = prefix + 'namethreadId'
export const noName = prefix + 'noNameId'

export const fullorder = prefix + 'fullorder'
export const renderingmode = prefix + 'renderingmode'
export const fullorderCombinations = prefix + 'fullorderCombinations'
export const firstVisit = prefix + 'firstVisit'
